import { render, staticRenderFns } from "./SafetyBuildAnnotation.vue?vue&type=template&id=5fe0e448&scoped=true&"
import script from "./SafetyBuildAnnotation.vue?vue&type=script&lang=js&"
export * from "./SafetyBuildAnnotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0e448",
  null
  
)

export default component.exports